<app-side-dialog data-testid="news-dialog" (closeDialog)="onCloseClick()">
  <div dialogHeader>
    @if (news().title) {
      <h2
        class="line-clamp-2 text-ellipsis"
        data-testid="news-dialog-title"
        matTooltip
        matTooltipPosition="below"
        matTooltipClass="justified-tooltip"
        [appTextClampTooltip]="news().title ?? ''"
      >
        {{ news().title }}
      </h2>
    }
  </div>

  <div dialogContent>
    <app-news [news]="[news()]" />
  </div>
</app-side-dialog>
